export const selectPreference = k => s => s.preference?.[k];
